<ng-container *ngIf="working">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="working === false && ready">
    <convfact-preinvoice-form [preinvoice]="preinvoice" [bankAccounts]="bankAccounts"
        [accountsAndTaxes]="accountsAndTaxes" [contactList]="contactList"
        (onSave)="saveData($event)"></convfact-preinvoice-form>
</ng-container>

<ng-container *ngIf="ready === false">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>